import { ReactNode } from 'react';
import { Typography } from '../../Typography';
import { ButtonStyled, ImageStyled } from './styled';

type ButtonImageProps = {
  srcImage?: string;
  onClick: () => void;
  children?: ReactNode;
};

export const ButtonImage = ({ onClick, children, srcImage, ...otherProps }: ButtonImageProps) => {
  return (
    <>
      <ButtonStyled fullWidth variant="image" onClick={onClick} {...otherProps}>
        {srcImage && <ImageStyled fill src={srcImage} alt="" />}
      </ButtonStyled>
      <Typography variant="text-body-sm">{children}</Typography>
    </>
  );
};
